import React, { useState, useEffect } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import objectPath from "object-path";
import { FaArrowLeft } from "react-icons/fa6";
import { useTranslation } from "react-i18next";
import FileUploadCustom from "../inputs/FileUploadCustom";
import Select from "react-select";
import { API_ROOT } from "../defines";
import { mainApi } from "../providers/api";
import Counter from "./components/Counter";
import Loading from "../components/Loading";
import { useApp } from "../providers/app";
import Swal from "sweetalert2";

const Custom = () => {
  const navigate = useNavigate();
  const { refreshNoti } = useApp();
  const { t } = useTranslation();
  const [material, setmaterial] = useState(null);
  const [materiallist, setmateriallist] = useState(null);
  const [size, setsize] = useState(null);
  const [sizelist, setsizelist] = useState(null);
  const [count, setcount] = useState(1);
  const [cart, setCart] = useState([]);
  const [text, settext] = useState(null);
  const [image, setimage] = useState(null);
  const [layout, setlayout] = useState("flex");
  const [priceLoading, setpriceLoading] = useState(false);
  const [priceObj, setPriceObj] = useState(null);
  const [price, setPrice] = useState(null);
  useEffect(() => {
    document.title = t("custom");
    const savedCart = localStorage.getItem("cart");

    if (savedCart) {
      setCart(JSON.parse(savedCart));
    }
    const fetchMaterial = async () => {
      const result = await mainApi({
        url: "/service/consts/material",
        method: "GET",
        auth: {
          username: "hsct",
          password:
            "769a9a905bbd4046903581605db75cad20fe84c70868d9874a628f09347c47df",
        },
      });
      setmateriallist(objectPath.get(result, "data"));
    };

    const fetchSize = async () => {
      const result = await mainApi({
        url: "/service/consts/size",
        method: "GET",
        auth: {
          username: "hsct",
          password:
            "769a9a905bbd4046903581605db75cad20fe84c70868d9874a628f09347c47df",
        },
      });

      setsizelist(objectPath.get(result, "data"));
    };
    fetchMaterial();
    fetchSize();
  }, []);
  useEffect(() => {
    const getPrice = async () => {
      try {
        setpriceLoading(true);
        const result = await mainApi({
          url: `/service/sign/price`,
          method: `POST`,
          auth: {
            username: "hsct",
            password: `769a9a905bbd4046903581605db75cad20fe84c70868d9874a628f09347c47df`,
          },
          data: {
            material: material,
            size: size,
          },
        });

        setPriceObj(objectPath.get(result, "data"));
        setpriceLoading(false);
      } catch (err) {
        setpriceLoading(false);
        console.log("err", err);
      }
    };
    size && material && getPrice();
  }, [size, material]);
  const basket = () => {
    const isCoat = objectPath.get(priceObj, "coat") == price;
    const sizeObj = sizelist?.find((row) => row._id == size);
    const materialObj = materiallist?.find((row) => row._id == material);
    const temp = [
      {
        id: null,
        type: t("custom"),
        image: objectPath.get(image, "0.id"),
        text: text,
        name: "special",
        size: size,
        sizeObj: sizeObj,
        material: material,
        materialObj: materialObj,
        isCoat: isCoat,
        price: price,
        count: count,
        total_price: price * count,
      },
      ...cart,
    ];
    localStorage.setItem("cart", JSON.stringify(temp));
    refreshNoti();
    Swal.fire({
      icon: "success",
      title: "已成功添加到您的购物车。",
      // title: "Таны сагсанд амжилттай нэмэгдлээ.",
      confirmButtonText: "命令",
      // confirmButtonText: "Захиалах",
      confirmButtonColor: "#1A2E55",
      denyButtonColor: "#9EA1A1",
      denyButtonText: "添加产品",
      // denyButtonText: "Бүтээгдэхүүн нэмэх",
      showDenyButton: true,
    }).then((result) => {
      if (result.isConfirmed) navigate("/order/basket");
      else navigate("/order/home");
    });
    // localStorage.clear();
  };
  return (
    <div className='flex w-full flex-col p-6 mb-32'>
      <div className='flex items-center'>
        <div
          onClick={() => navigate(-1)}
          className='flex w-8 h-8 justify-center items-center border border-primary rounded-md hover:cursor-pointer'
        >
          <FaArrowLeft color='#1A2E55' size={15} />
        </div>
        <div className='font-medium ml-2'>{t("custom")}</div>
      </div>

      <div className='flex w-full flex-wrap'>
        <div className='flex w-full md:w-1/2 flex-col'>
          <div className='flex p-8 border border-gray-300 mt-4 rounded w-4/5 self-center md:h-96 justify-center'>
            <div
              className={`${layout} border-2 border-black rounded-lg justify-center items-center w-96 h-64`}
            >
              {text == null && image == null && (
                <div className='flex w-full justify-center text-sm px-2 md:px-0 text-center text-gray-400'>
                  {t("file_placeholder")}
                </div>
              )}
              {text && <div className='justify-center m-2'>{text}</div>}
              {image && (
                <img
                  className='w-24'
                  crossOrigin='anonymous bg-contain self-center'
                  src={API_ROOT + "/" + objectPath.get(image, "0.id")}
                />
              )}
            </div>
          </div>
        </div>
        <div className='flex w-full md:w-1/2 flex-col p-4 md:p-0'>
          <div className='flex flex-col'>
            <div>{t("picture")}</div>
            <FileUploadCustom value={image} root='custom' onChange={setimage} />
          </div>

          <div className='flex flex-col mt-4'>
            <div>{t("text")}</div>
            <input
              placeholder={t("write")}
              value={text}
              onChange={(e) => {
                settext(e.target.value);
              }}
            />
          </div>
          <div className='flex flex-wrap mt-4'>
            <div
              onClick={() => setlayout("flex")}
              className={`w-32 flex justify-center m-1 items-center p-2 border-gray-500 border rounded-md text-sm hover:cursor-pointer hover:bg-primary hover:text-white ${
                layout == "flex" && "bg-primary text-white"
              }`}
            >
              {"文字在前面"}
              {/* Бичвэр урдаа */}
            </div>
            <div
              onClick={() => setlayout("flex flex-row-reverse")}
              className={`w-32 flex justify-center m-1 items-center p-2 border-gray-500 border rounded-md text-sm hover:cursor-pointer hover:bg-primary hover:text-white md:mx-2 ${
                layout == "flex flex-row-reverse" && "bg-primary text-white"
              }`}
            >
              幕后
              {/* Бичвэр ардаа */}
            </div>
            <div
              onClick={() => setlayout("flex flex-col")}
              className={`w-32 flex justify-center m-1 items-center p-2 border-gray-500 border rounded-md text-sm hover:cursor-pointer hover:bg-primary hover:text-white md:mx-2 ${
                layout == "flex flex-col" && "bg-primary text-white"
              }`}
            >
              关于文本
              {/* Бичвэр дээр */}
            </div>
            <div
              onClick={() => setlayout("flex flex-col-reverse")}
              className={`w-32 flex justify-center  m-1 items-center p-2 border-gray-500 border rounded-md text-sm hover:cursor-pointer hover:bg-primary hover:text-white ${
                layout == "flex flex-col-reverse" && "bg-primary text-white"
              }`}
            >
              正文下方
              {/* Бичвэр доор */}
            </div>
          </div>
          <div className='flex flex-col mt-4'>
            <div className='text-disabled font-normal italic text-sm'>
              {t("detail.material")}
            </div>
            <div className='md:flex hidden font-medium flex-wrap'>
              {materiallist?.map((row, index) => {
                return (
                  <div
                    onClick={() => setmaterial(objectPath.get(row, "_id"))}
                    className={`border p-1 px-2 border-primary m-1 text-xs font-medium rounded-md hover:cursor-pointer hover:text-white hover:bg-primary ${
                      material == objectPath.get(row, "_id") &&
                      `bg-primary text-white`
                    }`}
                    key={index}
                  >
                    {objectPath.get(row, "name")}
                  </div>
                );
              })}
            </div>
            <div className='flex md:hidden'>
              {materiallist && (
                <Select
                  className='w-full'
                  placeholder={t("choose")}
                  value={material}
                  onChange={setmaterial}
                  getOptionValue={(option) => option._id}
                  getOptionLabel={(option) => option.name}
                  options={materiallist}
                />
              )}
            </div>
          </div>
          <div className='flex flex-col mt-4'>
            <div className='text-disabled font-normal italic text-sm'>
              {t("detail.size")}
            </div>
            <div className='font-medium md:flex hidden flex-wrap'>
              {sizelist?.map((row, index) => {
                return (
                  <div
                    onClick={() => setsize(objectPath.get(row, "_id"))}
                    className={`border p-1 px-2 border-primary m-1 font-medium text-xs rounded-md hover:cursor-pointer hover:text-white hover:bg-primary ${
                      size == objectPath.get(row, "_id") &&
                      `bg-primary text-white`
                    }`}
                    key={index}
                  >
                    {objectPath.get(row, "name")}
                  </div>
                );
              })}
            </div>
            <div className='flex md:hidden'>
              {sizelist && (
                <Select
                  className='w-full'
                  placeholder={t("choose")}
                  value={size}
                  onChange={setsize}
                  getOptionValue={(option) => option._id}
                  getOptionLabel={(option) => option.name}
                  options={sizelist}
                />
              )}
            </div>
          </div>
          {size && material && (
            <div className='flex'>
              {priceLoading ? (
                <Loading width='w-4' />
              ) : (
                <div className='flex'>
                  <div className='mb-2 mr-4'>
                    <div className='text-disabled font-normal italic text-sm'>
                      {t("detail.price")}
                    </div>
                    <div
                      className={`flex p-1 px-2 text-sm border-primary border rounded justify-center items-center font-medium hover:cursor-pointer hover:text-white hover:bg-primary ${
                        objectPath.get(priceObj, "price") == price &&
                        "bg-primary text-white"
                      }`}
                      onClick={() => {
                        setPrice(objectPath.get(priceObj, "price"));
                      }}
                    >
                      {`${objectPath
                        .get(priceObj, "price")
                        ?.toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}¥`}
                    </div>
                  </div>
                  {/* <div className="mb-2">
                    <div className="text-disabled font-normal italic text-sm">
                      Бүрэлттэй үнэ
                    </div>
                    <div
                      onClick={() => {
                        setPrice(objectPath.get(priceObj, "coat"));
                      }}
                      className={`flex  p-1 px-2 text-sm border-primary border rounded justify-center items-center font-medium hover:cursor-pointer hover:text-white hover:bg-primary ${
                        objectPath.get(priceObj, "coat") == price &&
                        "bg-primary text-white"
                      }`}
                    >
                      {`${objectPath
                        .get(priceObj, "coat")
                        ?.toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}¥`}
                    </div>
                  </div> */}
                </div>
              )}
            </div>
          )}
          {size && material && price && (
            <div className='flex flex-col'>
              <Counter count={count} setcount={setcount} />
              <div className='flex mt-4'>
                <div
                  className='flex justify-center items-center rounded w-40 border border-primary p-2  hover:cursor-pointer'
                  onClick={() => basket()}
                >
                  <div className='text-black text-base font-medium'>
                    {t("detail.basket")}
                  </div>
                </div>
                <NavLink
                  to='/order/basket'
                  className='flex justify-center items-center rounded w-40 border border-primary p-2 ml-4 bg-primary hover:cursor-pointer'
                >
                  <div className='text-white text-base font-medium '>
                    {t("detail.buy")}
                  </div>
                </NavLink>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Custom;
